import { useCallback, useEffect, useMemo, useState } from "react";
import { PROFILES, STORAGE } from "../constants";
import { useSession } from "../hooks/useSession";
import { LocalStorageService } from "../services/LocalStorageService";


interface useHasAccessProps {
    onlyRoot?: boolean;
    permission?: string;
}


function useHasAccess({ onlyRoot, permission }: useHasAccessProps) {

    const { session } = useSession();

    const [ isAllowed, setIsAllowed] = useState(null)
    const [permissions] = useState(LocalStorageService.get(STORAGE.PERMISSIONS))

    const profile = useMemo(() => session.profile.toLowerCase(), [session])

    const findValue = useCallback(() => {
        const chunks = permission.split('.');

        let value;
        for (const key of chunks) {
            if (!value) {
                value = permissions;
            }

            value = value[key]
        }

        return value;
    },
        [permission]
    )


    useEffect(() => {
        if (onlyRoot && profile !== PROFILES.ROOT) return setIsAllowed(false);

        if (profile === PROFILES.ROOT || profile === PROFILES.ADMIN) return setIsAllowed(true);

        if (profile === PROFILES.SUPERVISOR) {
            const value = findValue()
            return value ? setIsAllowed(true) : setIsAllowed(false);
        }

        return setIsAllowed(false);
    }, [])


    return {
        isAllowed
    }
}
export default useHasAccess